import { ComponentChildren, h } from "preact";
import "./toolbar.scss";

export function Toolbar(props: { class?: string, children?: ComponentChildren }) {
    return (
        <div className={"component4-toolbar" + (props.class ? (" " + props.class) : "")}>
            {props.children}
        </div>
    );
}
